var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-agreement"},[_c('h2',[_vm._v("隐私声明")]),_c('div',{staticClass:"details",domProps:{"innerHTML":_vm._s(_vm.detail)}}),_c('div',{staticClass:"history-version",on:{"click":function($event){return _vm.$router.push('/privacyHistory')}}},[_vm._v("查看隐私政策历史版本>>")])])
}
var staticRenderFns = []

export { render, staticRenderFns }